<template>
  <div id="app">
    <Navbar v-if="!isFullScreen" @notice-change="noticeDialog"/>
    <router-view :key="key" />
    <Bomter v-if="!isFullScreen" />
    <Notice ref="nForm"/>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import Bomter from "@/components/Bomter";
import Notice from "@/components/customAnnouncement";

export default {
  name: "App",
  components: {
    Navbar,
    Bomter,
    Notice,
  },
  methods:{
    noticeDialog() {
      let _this = this.$refs.nForm
      _this.dialog = true
    },
  },
  computed: {
    //router-view指定唯一key,路由切换时重新渲染触发钩子
    key() {
      return this.$route.path !== undefined
        ? this.$route.path + +new Date()
        : this.$route + +new Date();
    },

    // 是否全屏(不展示头部和底部)
    isFullScreen() {
      const fullScreenRoutes = ["/protocol"];
      return fullScreenRoutes.includes(this.$route.path);
    },
  },
  // watch:{
  //   '$route.path'(newval,oldval){
  //     console.log('newval',newval,'---','oldval',oldval);
  //     if(newval!==oldval){
  //       this.num++
  //     }
  //   }
  // }
};
</script>

<style>
#app {
  width: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}

body {
  padding: 0;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue